import { LmsFormActions } from './enum';
import { LmsForm, LmsOpener, LmsResponse } from './interface';

export const submitLmsForm = () => ({
    type: LmsFormActions.SUBMIT_LMS_FORM,
} as const);

export const handleLmsResponse = (payload: LmsResponse) => ({
    type: LmsFormActions.HANDLE_LMS_RESPONSE,
    payload,
} as const);

export const changeLmsInput = (payload: Partial<LmsForm>) => ({
    type: LmsFormActions.CHANGE_LMS_INPUT,
    payload,
} as const);

export const setLmsOpener = (openedBy: LmsOpener) => ({
    type: LmsFormActions.SET_LMS_OPENER,
    openedBy,
} as const);

export const clearLmsResult = () => ({
    type: LmsFormActions.CLEAR_LMS_RESULT,
} as const);

export type Actions = ReturnType<typeof submitLmsForm>
    | ReturnType<typeof handleLmsResponse>
    | ReturnType<typeof changeLmsInput>
    | ReturnType<typeof setLmsOpener>
    | ReturnType<typeof clearLmsResult>;
